// services
import { BaseService } from '@/services/BaseService';
// dto
import { BaseContentDto } from '../dto/base-content.dto';
import {
  DashboardUserGroupsContentsListDto,
  DashboardUserGroupsContentsListFilterDto,
} from './dto';

class DashboardUserGroupsContentsService extends BaseService {
  getContent(contentId: number) {
    return this.get(`${contentId}`);
  }
  postContentsList(page = 1, size = 10, filter: DashboardUserGroupsContentsListFilterDto) {
    return this.post<DashboardUserGroupsContentsListDto[]>(``, filter, { params: { page, size } });
  }
  postAttendees(contentId: number) {
    return this.post(`${contentId}/attendees`);
  }
  getPurchaseDetail(contentId: number, purchaseId: number) {
    return this.get(`${contentId}/purchases/${purchaseId}`);
  }
  postAffiliates(contentId: number) {
    return this.post(`${contentId}/affiliates`);
  }
  postInvitedUsers(contentId: number) {
    return this.post(`${contentId}/invited-users`);
  }
  getCalendar() {
    return this.get(`calendar`);
  }
  getPitchEvents() {
    return this.get(`pitch-events`);
  }
  postContents(eventType: string, eventData: any) {
    return this.post(`${eventType}`, eventData);
  }
  putContents(contentId: number, eventType: string, eventData: Partial<BaseContentDto>) {
    return this.put(`${contentId}/${eventType}`, eventData);
  }
  deleteContents(contentId: number) {
    return this.delete(`${contentId}`);
  }
}
export default new DashboardUserGroupsContentsService('/dashboard/user-groups/contents');
